import { BrowserRouter as Router } from 'react-router-dom';
import Scenes from './scenes';
import { AuthProvider, PageTracker, AuthModal, ScrollToTop, EnvFlag, EnvFooter } from '@omnigenbiodata/ui';
import ROUTES from './core/constants/routes.constant';
import ENV from './core/constants/environment.constant';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <AuthProvider authPath={ROUTES.auth} postLoginPath={ROUTES.root} postLogoutPath={ROUTES.authSignOut}>
        <PageTracker />
        <AuthModal message="Your session will expire in 5 minutes. Please ensure you have completed your work, or sign out now." />
        <Scenes />
        <EnvFlag env={ENV.ENVIRONMENT} version={ENV.VERSION} />
        <EnvFooter env={ENV.ENVIRONMENT as any} version={ENV.FULL_VERSION} />
      </AuthProvider>
    </Router>
  );
}

export default App;
